interface JsonLdProps {
  data: Record<string, unknown>;
}

/**
 * Renders a JSON-LD structured data script tag.
 * Safe to use dangerouslySetInnerHTML here because the data is
 * always developer-controlled static schemas, never user input.
 */
export default function JsonLd({ data }: JsonLdProps) {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}

export function BreadcrumbJsonLd({ pageName, pageUrl }: { pageName: string; pageUrl: string }) {
  // The trailing-slash form, matching the canonical and the sitemap: it is the
  // only form Cloudflare Pages serves as 200 rather than a redirect.
  const pagePath = pageUrl.endsWith("/") ? pageUrl : `${pageUrl}/`;
  return (
    <JsonLd data={{
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://capsulechichub.com/",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: pageName,
          item: `https://capsulechichub.com${pagePath}`,
        },
      ],
    }} />
  );
}
